module.exports = __webpack_public_path__ + "img/Confused_emoji-removebg-preview 1.fbaff63b.png";